module.exports = __webpack_public_path__ + "img/calculo-cuota.854f5ef1.png";